module.exports = __webpack_public_path__ + "static/media/image-576.0515df92.jpg";